import * as ActionTypes from '../action-types'

export function authLogin(payload){
    return {
        type: ActionTypes.AUTH_LOGIN,
        payload
    }
}

export function changePassword(){
    return {
        type: ActionTypes.AUTH_CHANGE_PASSWORD,
    }
}


export function authLogout(){
    return {
        type: ActionTypes.AUTH_LOGOUT
    }
}

export function authCheck(){
    return {
        type:ActionTypes.AUTH_CHECK
    }
}

export function authBalance(payload){
    return {
        type:ActionTypes.AUTH_BALANCE,
        payload
    }
}

export function setPayments(payload){
    return {
        type:ActionTypes.PAYMENTS,
        payload
    }
}
